
import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { persistReducer, persistStore } from "redux-persist";

// Importing all your slices
import loginSlice from "./slices/loginSlice";
import loginSlice2 from "./slices/loginSlice2";
import aadharSlice from "./slices/aadharSlice";
import addressSlice from "./slices/addressSlice";
import bank_augmontsSlice from "./slices/bank_augmontsSlice";
import usersSlice from "./slices/usersSlice";
import banksSlice from "./slices/banksSlice";
import transectionSlice from "./slices/transectionSlice";
import proposalSlice from "./slices/proposalSlice";
import partner_registerSlice from "./slices/partner_registerSlice";
import login_tableSlice from "./slices/login_tableSlice";
import employeeSlice from "./slices/employeeSlice";
import clientSlice from "./slices/clientSlice";
import buy_requestsSlice from "./slices/buy_requestsSlice";
import buy_responseSlice from "./slices/buy_responseSlice";
import sell_requestSlice from "./slices/sell_requestSlice";
import buy_InvoiceSlice from "./slices/buy_InvoiceSlice";
import redeem_InvoiceSlice from "./slices/redeem_InvoiceSlice";
import sell_InvoiceSlice from "./slices/sell_InvoiceSlice";
import mandateSlice from "./slices/mandateSlice";
import sipSlice from "./slices/sipSlice";
import userSlice from "./slices/userSlice";
import orderSlice from "./slices/orderSlice";
import user_augmontSlice from "./slices/user_augmontSlice";
import withdraw_augmontSlice from "./slices/withdraw_augmontSlice";
import state_augmontSlice from "./slices/state_augmontSlice";
import settingsSlice from "./slices/settingsSlice";
import queriesSlice from "./slices/queriesSlice";
import mobileQueriesSlice from "./slices/mobileQueriesSlice";
import citySlice from "./slices/citySlice";
import stateSlice from "./slices/stateSlice";
import transferSlice from "./slices/transferSlice";
import referralSlice from "./slices/referralSlice";
import preferenceSlice from "./slices/preferenceSlice";
import panSlice from "./slices/panSlice";
import nomineeSlice from "./slices/nomineeSlice";
import mmtc_sell_responseSlice from "./slices/mmtc/mmtc_sell_responseSlice";
import mmtc_sell_requestSlice from "./slices/mmtc/mmtc_sell_requestSlice";
import mmtc_redeemSlice from "./slices/mmtc/mmtc_redeemSlice";
import mmtc_buy_responseSlice from "./slices/mmtc/mmtc_buy_responseSlice";
import mmtc_buy_requestSlice from "./slices/mmtc/mmtc_buy_requestSlice";
import newDashboardSlice from "./slices/mmtc/newDashboardSlice";
import logSlice from "./slices/logSlice";
import kycSlice from "./slices/kycSlice";
import initiateConfirmTransferSlice from "./slices/initiateConfirmTransferSlice";
import countriesSlice from "./slices/countriesSlice";
import devicesSlice from "./slices/devicesSlice";
import sellAugmontSlice from "./slices/sellAugmontSlice";
import redeemSlice from "./slices/redeemSlice";
import addProductCartSlice from "./slices/cart/addProductCartSlice";
import getProductCartSlice from "./slices/cart/getProductCartSlice";
import removeProductCartSlice from "./slices/cart/removeProductCartSlice";
import productQuantityCartSlice from "./slices/cart/productQuantityCartSlice";
import spotGoldSlice from "./slices/spotGold/spotGoldSlice";
import spotGoldProductDetailsSlice from "./slices/spotGold/spotGoldProductDetailsSlice";
import userAddressSlice from "./slices/user/userAddressSlice";
import userListSlice from "./slices/user/userListSlice";
import profileSlice from "./slices/profileSlice";
import razorpaySpotGoldOrderSlice from "./slices/razorpay/razorpaySpotGoldOrderSlice";
import razorpayOrderSlice from "./slices/razorpay/razorpayOrderSlice";
import razorpayPostOrderSlice from "./slices/razorpay/razorpayPostOrderSlice";
import augmontstateSlice from "./slices/address/stateSlice";
import augmontcitySlice from "./slices/address/citySlice";
import historySlice from "./slices/history/historySlice";
import notificationSlice from "./slices/notificationSlice";
import partnerNotificationSlice from "./slices/partnerNotificationSlice";
import help_and_supportSlice from "./slices/help_and_supportSlice";
import singleUserChatSlice from "./slices/singleUserChatSlice";
import refundPaymentSlice from "./slices/refundPaymentSlice";
import importPartnerSlice from "./slices/importPartnerSlice";
import parnerReportCommissionSlice from "./slices/parnerReportCommissionSlice";
import batukPartnerSlice from "./slices/batukPartner/batukPartnerSlice";
import buySlice from "./slices/buySlice";
import sellSlice from "./slices/sellSlice";
import redeemSliceFintso from "./slices/redeemSliceFintso";
import spotSlice from "./slices/spotSlice";
import sipMiningSlice from "./slices/sipMining";
import complianceReportSlice from "./slices/reports/complianceReportSlice";
import inactiveClientSlice from "./slices/reports/inactiveClientSlice";
import fileImportHistorySlice from "./slices/reports/fileImportHistorySlice";
import sipBusinessReportSlice from "./slices/reports/sipBusinessReportSlice";
import LumpsumSlice from "./slices/reports/LumpsumSlice";
import sipBookingSlice from "./slices/reports/sipBookingSlice";
import partnerListSlice from "./slices/reports/partnerListSlice";
import missingSipSlice from "./slices/reports/missingSipSlice";
import partnerInvoiceSlice from "./slices/partnerInvoice/partnerInvoiceSlice";
import viewInvoiceSlice from "./slices/partnerInvoice/viewInvoiceSlice";
import sendInvoiceSlice from "./slices/partnerInvoice/sendInvoiceSlice";
import partnerTransactionSlice from "./slices/partnerInvoice/partnerTransactionSlice";
import updatePaymentSlice from "./slices/partnerInvoice/updatePaymentSlice";
import uploadTemplateSlice from "./slices/templateCreation/uploadTemplateSlice";
import getAllTemplateSlice from "./slices/templateCreation/getAllTemplateSlice";
import getSalesTargetSlice from "./slices/salesTarget/getSalesTargetSlice";
import createSalesTargetSlice from "./slices/salesTarget/createSalesTargetSlice";
import deleteTemplateSlice from "./slices/templateCreation/deleteTemplateSlice";
import deleteSalesTargetSlice from "./slices/salesTarget/deleteSalesTargetSlice";
import updateSalesTargetSlice from "./slices/salesTarget/updateSalesTargetSlice";
import updateTemplateSlice from "./slices/templateCreation/updateTemplateSlice";
import OrderQuoteSlice from "./slices/spotGoldQuote/OrderQuoteSlice";
import PartnerOrderQuoteSlice from "./slices/spotGoldQuote/PartnerOrderQuoteSlice";
import redeemQuoteSlice from "./slices/redeems/redeemQuoteSlice";
import sellStatusSlice from "./slices/kycUpdate/sellStatusSlice";
import updateKycSlice from "./slices/kycUpdate/updateKycSlice";
import withdrawalSlice from "./slices/kycUpdate/withdrawalSlice";
import collateralSlice from "./slices/collateral/collateralSlice";
import uploadCollateralSlice from "./slices/collateral/uploadCollateralSlice";
import mediaTemplateSlice from "./slices/collateral/mediaTemplateSlice";
import updateCollateralSlice from "./slices/collateral/updateCollateralSlice";
import updateMediaSlice from "./slices/collateral/updateMediaSlice";
import partnerCommissionSlice from "./slices/partnerCommissionReport/partnerCommissionSlice";
import mutualFundSlice from "./slices/MFD/mutualFundSlice";
import homeBannerSlice from "./slices/homeBanner/homeBannerListSlice";
import webBannerSlice from "./slices/homeBanner/webBannerSlice";
import activePartnerSlice from "./slices/partnerReport/activePartnerSlice";
import inactivePartnerSlice from "./slices/partnerReport/inactivePartnerSlice";
import rewardSystemSlice from "./slices/rewardSystemSlice";
import giftCardSlice from "./slices/giftCardSlice";
import partnergiftCardSlice from "./slices/partnergiftCardSlice";
import policySlice from "./slices/policySlice";
import faqSlice from "./slices/faqSlice";
import gstSlice from "./slices/gstSlice";
// import dsrSlice from "./slices/dsrSlice";
import giftCardUsedSlice from "./slices/giftCardUser/giftCardUsedSlice";
import giftCardUnusedSlice from "./slices/giftCardUser/giftCardUnusedSlice";
import bajajDashboardSlice from "./slices/bajajDashboardSlice";

// Config for Redux Persist
const loginPersistConfig = {
  key: "login",
  storage,
  // whitelist: ["login2"], // Persist only the login state
};

const persistedLoginReducer = persistReducer(loginPersistConfig, loginSlice2);

// Create Store
export const store = configureStore({
  reducer: {
    login: persistedLoginReducer, // Use persisted reducer for login
    aadhar: aadharSlice,
    address: addressSlice,
    bank_augmonts: bank_augmontsSlice,
    users: usersSlice,
    userList: userListSlice,
    banks: banksSlice,
    transection: transectionSlice,
    proposal: proposalSlice,
    partner_register: partner_registerSlice,
    login_table: login_tableSlice,
    employee: employeeSlice,
    client: clientSlice,
    buy_requests: buy_requestsSlice,
    buy_response: buy_responseSlice,
    sell_request: sell_requestSlice,
    buy_Invoice: buy_InvoiceSlice,
    redeem_Invoice: redeem_InvoiceSlice,
    sell_Invoice: sell_InvoiceSlice,
    mandate: mandateSlice,
    sip: sipSlice,
    user: userSlice,
    order: orderSlice,
    user_augmont: user_augmontSlice,
    withdraw_augmont: withdraw_augmontSlice,
    state_augmont: state_augmontSlice,
    settings: settingsSlice,
    queries: queriesSlice,
    city: citySlice,
    state: stateSlice,
    transfer: transferSlice,
    referral: referralSlice,
    preference: preferenceSlice,
    pan: panSlice,
    nominee: nomineeSlice,
    mmtc_sell_response: mmtc_sell_responseSlice,
    mmtc_sell_request: mmtc_sell_requestSlice,
    mmtc_redeem: mmtc_redeemSlice,
    mmtc_buy_response: mmtc_buy_responseSlice,
    mmtc_buy_request: mmtc_buy_requestSlice,
    newDashboard: newDashboardSlice,
    bajajDashboard: bajajDashboardSlice,
    log: logSlice,
    kyc: kycSlice,
    initiateConfirmTransfer: initiateConfirmTransferSlice,
    countries: countriesSlice,
    devices: devicesSlice,
    sell_Augmont: sellAugmontSlice,
    redeem_order: redeemSlice,
    addProductCartSlice,
    getProductCartSlice,
    removeProductCartSlice,
    productQuantityCartSlice,
    spotGoldSlice,
    spotGoldProductDetailsSlice,
    userAddressSlice,
    profileSlice,
    razorpaySpotGoldOrderSlice,
    razorpayOrderSlice,
    razorpayPostOrderSlice,
    augmontcitySlice,
    augmontstateSlice,
    historySlice,
    notification: notificationSlice,
    partnerNotification: partnerNotificationSlice,
    help_and_support: help_and_supportSlice,
    singleUserChat: singleUserChatSlice,
    refundPayment: refundPaymentSlice,
    importPartner: importPartnerSlice,
    batukPartner: batukPartnerSlice,
    parnerReportCommission: parnerReportCommissionSlice,
    buySlice: buySlice,
    sellSlice: sellSlice,
    redeemSlice: redeemSliceFintso,
    spotSlice: spotSlice,
    // parnerReportCommission:parnerReportCommissionSlice,
    mobileQueries: mobileQueriesSlice,
    Lumpsum: LumpsumSlice,
    sipBooking: sipBookingSlice,
    sipMining: sipMiningSlice,
    complianceReport: complianceReportSlice,
    inactiveClient: inactiveClientSlice,
    fileImportHistory: fileImportHistorySlice,
    sipBusinessReport: sipBusinessReportSlice,
    partnerList: partnerListSlice,
    missingSip: missingSipSlice,
    partnerInvoice: partnerInvoiceSlice,
    viewInvoice: viewInvoiceSlice,
    sendInvoice: sendInvoiceSlice,
    partnerTransaction: partnerTransactionSlice,
    updatePayment: updatePaymentSlice,
    uploadTemplate: uploadTemplateSlice,
    createSalesTarget: createSalesTargetSlice,
    getAllTemplate: getAllTemplateSlice,
    getSalesTarget: getSalesTargetSlice,
    deleteTemplate: deleteTemplateSlice,
    deleteSalesTarget: deleteSalesTargetSlice,
    OrderQuote: OrderQuoteSlice,
    PartnerOrderQuote: PartnerOrderQuoteSlice,
    updateTemplate: updateTemplateSlice,
    updateSalesTarget: updateSalesTargetSlice,
    redeemQuote: redeemQuoteSlice,
    sellStatus: sellStatusSlice,
    updateKyc: updateKycSlice,
    withdrawal: withdrawalSlice,
    collateral: collateralSlice,
    uploadCollateral: uploadCollateralSlice,
    updateCollateral: updateCollateralSlice,
    partnerCommission: partnerCommissionSlice,
    mfd: mutualFundSlice,
    mediaTemplate: mediaTemplateSlice,
    homeBanner: homeBannerSlice,
    rewardSystem: rewardSystemSlice,
    giftCard: giftCardSlice,
    partnergiftCard: partnergiftCardSlice,
    policy: policySlice,
    faq: faqSlice,
    webBanner: webBannerSlice,
    activePartner: activePartnerSlice,
    inactivePartner: inactivePartnerSlice,
    updatemediatemplate: updateMediaSlice,
    gst: gstSlice,
    giftCardUsed: giftCardUsedSlice,
    giftCardUnused: giftCardUnusedSlice,
    // dsr: dsrSlice,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"], // Ignore non-serializable action types
      },
    }),
});

// Persistor
export const persistor = persistStore(store);
